import '/node_modules/ol-layerswitcher/dist/ol-layerswitcher.css'
import LayerSwitcher from 'ol-layerswitcher'

export function createLayerSwitcher(options = {}) {
  return new LayerSwitcher({
    reverse: false,
    groupSelectStyle: 'none', // 'children' [default] | 'group' | 'none'
    tipLabel: 'Légende', // Optional label for button
    // activationMode: 'click',
    ...options,
  })
};
